import Cookies from 'react-cookies';
import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import COOKIES from '../config/cookies/cookies';
import { URLSUBSCRIBE, URLNOTIFYME } from '../config/setup/setup';
import httpCommonHeaders from './httpCommonHeaders';
import { getUserLocationShortName } from './user';

export const subscribeUser = async (email) => {
  const { data } = await axios({
    data: {
      email,
      location: getUserLocationShortName(),
      subscriptionSource: Cookies.load(COOKIES.userSource) || '',
    },
    headers: httpCommonHeaders(),
    method: 'POST',
    url: URLSUBSCRIBE,
    validateStatus: (status) => {
      return status < 500;
    },
  });

  return data;
};

export const notifyUser = async (email, dealVoucherId) => {
  return await axios({
    data: {
      dealVoucherId,
      email,
    },
    headers: httpCommonHeaders(),
    method: 'POST',
    url: URLNOTIFYME,
    validateStatus: (status) => {
      return status < 500;
    },
    withCredentials: true,
  });
};
